import React from "react";
import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import Iconify from "../../components/Iconify";
import Reveal from "../../components/Reveal";
import { INK, ACCENT, BeltStripe } from "../../theme/brand";
import { ALL_FEATURES } from "./content";

export default function AllFeatures() {
  return (
    <Box sx={{ px: { xs: 2, md: 4 }, pb: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg" disableGutters>
        <Reveal sx={{ bgcolor: INK, color: "#fff", borderRadius: 4, overflow: "hidden" }}>
          <BeltStripe height={4} />
          <Box sx={{ p: { xs: 3, sm: 4, md: 8 } }}>
            <Stack spacing={1} sx={{ mb: 5 }}>
              <Typography variant="overline" sx={{ color: ACCENT, fontWeight: 700, letterSpacing: 2 }}>
                Alles drin
              </Typography>
              <Typography variant="h4" component="h2" fontWeight={800}>
                Alle Funktionen im Überblick
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.6)" }}>
                Keine Module, keine Aufpreise – jede Funktion ist in jedem
                Tarif enthalten.
              </Typography>
            </Stack>

            <Grid container spacing={{ xs: 1.5, md: 2.5 }}>
              {ALL_FEATURES.map((feature) => (
                <Grid item xs={12} sm={6} md={4} key={feature}>
                  <Stack direction="row" spacing={1.5} alignItems="flex-start">
                    <Box
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        bgcolor: "rgba(139,127,234,0.18)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        mt: 0.25,
                      }}
                    >
                      <Iconify icon="mdi:check" width={14} sx={{ color: ACCENT }} />
                    </Box>
                    <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.85)" }}>
                      {feature}
                    </Typography>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Reveal>
      </Container>
    </Box>
  );
}
